import React from "react";

import { Grid, Cell } from "../../components/ui";
import { FormattedContentItem } from "../../components/content";

import { useStyletron } from "baseui";
import { HeadingXXLarge, LabelMedium } from "baseui/typography";

const Heading = () => {
  const [css, theme] = useStyletron();

  return (
    <article
      data-csweb="careers-heading"
      className={css({
        backgroundColor: theme.colors.backgroundSecondary,
        paddingTop: theme.sizing.scale4800,
        paddingBottom: theme.sizing.scale4800,
        [theme.breakpoints.mediaQueries.medium]: {
          paddingTop: theme.sizing.scale2400,
        },
      })}
    >
      <Grid>
        <Cell span={12}>
          <HeadingXXLarge $style={{ textAlign: "center" }}>
            <FormattedContentItem scope="Careers" accessor="heading" />
          </HeadingXXLarge>
          <LabelMedium $style={{ textAlign: "center", fontWeight: "700" }}>
            <FormattedContentItem scope="Careers" accessor="subheading" />
          </LabelMedium>
        </Cell>
      </Grid>
    </article>
  );
};

export default Heading;
